import { Data } from "./types";
import {
  UPDATE_FAVORITE_REQUEST,
  UPDATE_FAVORITE_SUCCESS,
  UPDATE_FAVORITE_ERROR,
  FETCH_LIST_FAVORITE_REQUEST,
  FETCH_LIST_FAVORITE_SUCCESS,
  FETCH_LIST_FAVORITE_ERROR,
  UPDATE_FAVORITE_LIST,
  FAVORITE_LIST_LOCAL,
} from "./actions";
import { AnyObject } from "yup";
import { megerArrayList } from "core/utils/helper";

export interface DataState {
  dataList: Data[];
  dataDetail: AnyObject;
  loading: boolean;
  loadingUpdate: boolean;
  stateActive: boolean;
  lastPage: number;
  error: Error | null;
  scrollPosition: number;
  params: AnyObject;
}

const initialState: DataState = {
  dataList: [],
  dataDetail: {},
  params:{
    order_by: "updated_at",
    order_dir: "desc",
    page: 1,
    page_size: 10,
  },
  loading: false,
  loadingUpdate: false,
  stateActive: false,
  lastPage: 0,
  error: null,
  scrollPosition: 0,
};

const favoriteReducer = (
  state: DataState = initialState,
  action: any
): DataState => {
  switch (action.type) {
    case FETCH_LIST_FAVORITE_REQUEST:
      console.log(action.payload, 'FETCH_LIST_FAVORITE_REQUEST')
      return { ...state, loading: true, error: null, params: action?.payload || state?.params };
    case FETCH_LIST_FAVORITE_SUCCESS: {
      let listData = megerArrayList(state.dataList as [],action.payload.data?.data)
      if (action.payload?.data?.current_page === 1) {
        listData = action.payload.data?.data;
      }
      
      return {
        ...state,
        dataList: listData,
        loading: false,
        error: null,
        lastPage: action.payload?.data?.last_page
      };
    }
    case FETCH_LIST_FAVORITE_ERROR:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_FAVORITE_REQUEST:
      return { 
        ...state, 
        loadingUpdate: true, 
        stateActive:action.payload?.stateActive, 
        error: null 
      };
    case UPDATE_FAVORITE_SUCCESS:
      return {
        ...state,
        dataDetail: action.payload,
        loadingUpdate: false,
        error: null,
      };
    case UPDATE_FAVORITE_ERROR:
      return { ...state, loadingUpdate: false, error: action.payload };
    case UPDATE_FAVORITE_LIST:
      return { ...state, loading: false, dataList: action.payload.data };
    case FAVORITE_LIST_LOCAL: {
      const paramsMap = state?.params || {
        order_by: "updated_at",
        order_dir: "desc",
        page: 1,
        page_size: 10,
      }
      if(!action.payload?.dataList.length){
        paramsMap.page = 1
      }
      return { 
        ...state, 
        scrollPosition: action.payload?.scrollPosition, 
        dataList: action.payload?.dataList,
        params: paramsMap, 
      };
    }
    default:
      return state;
  }
};

export default favoriteReducer;
